import React, { useState, useEffect } from 'react';
import {ByStatusOrders, getUser} from "../graphql/queries"
import { updateOrder} from "../graphql/mutations"
import { API, graphqlOperation } from 'aws-amplify'

import {onCreateOrder} from '../graphql/subscriptions'
import {
    Button,
    Notification,
    Message,
    MessageBox,
  } from 'element-react'
import { EmptyMsg,
} from '../components/OrderStyles'
import NumberPager from '../components/NumberPager'
import OrderSearch, { filterOrders, emptyFilters, hasActiveFilters } from '../components/OrderSearch'
import OrderCardItem from '../components/OrderCardItem'

const PAGE_SIZE = 10
const MAX_ORDERS = 1000

function CustomerOrder({ user, userAttributes }) {
    const [isLoading, setIsLoading] = useState(false);
    const [updateProductDialog, setupdateProductDialog] = useState(false);
    const [shipped, setshipped] = useState(false);
    const [status, setstatus] = useState([]);
    const [statusValues, setStatusValues] = useState([ "Ready for Pickup"]);
    const [allOrders, setAllOrders] = useState([])
    const [page, setPage] = useState(1)
    const [filters, setFilters] = useState({ ...emptyFilters })
    const [isAdmin, setAdmin] = useState(false);

    useEffect(() => {
      let isMounted = true
      /* fetch everything once and page client-side, so the pager can show
         real page numbers (the API has no total count) */
      const fetchAll = async () => {
        setIsLoading(true)
        try {
          const input = {
            id: userAttributes.sub,
            limit: 999,
            sortDirection: 'DESC',
          }

          const resulting = await API.graphql(graphqlOperation(getUser, input))
          if (resulting.data.getUser.admin) {
            if (isMounted) setAdmin(true)
            let items = []
            let token
            do {
              const variables = {
                nextToken: token,
                limit: 100,
                status: "Processing",
                sortDirection: 'DESC',
              }
              const result = await API.graphql(
                graphqlOperation(ByStatusOrders, variables)
              )
              items = items.concat(result.data.ByStatusOrders.items)
              token = result.data.ByStatusOrders.nextToken
            } while (token && items.length < MAX_ORDERS)
            if (isMounted) setAllOrders(items)
          } else {
            console.log(resulting)
            if (isMounted) setAllOrders(resulting.data.getUser.orders.items)
          }
        } catch (err) {
          console.log(err)
        } finally {
          if (isMounted) setIsLoading(false)
        }
      }

      fetchAll()

      return () => {
        isMounted = false
      }
    }, [userAttributes.sub])

    const filteredOrders = filterOrders(allOrders, filters)
    const pageCount = Math.ceil(filteredOrders.length / PAGE_SIZE)

    const goToPage = (p) => {
      setPage(p)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const handleFilters = (f) => {
      setFilters(f)
      setPage(1)
    }


 
    // Subscribe to creation of Order
    const subscription = API.graphql(
      graphqlOperation(onCreateOrder)
    ).subscribe({
      next: ({ provider, value }) => {
        console.log({ provider, value })
        isAdmin && (Notification({
          title: "Order Notification",
          message: "New Order Received !",
          type: "success",
          duration: 3000,
          onClose: () => {
           window.location = '/profile'
            window.location.reload()
            fetch()

          },
        }));
      },
      error: error => console.warn(error)
    });

   

  const handleCancelOrder = (Order) => {
    MessageBox.confirm(
      'This will permanently cancel your Order! Continue?',
      'Attention!',
      {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }
    )
      .then(async () => {
        try {

          console.log("my order ", Order);
          const input = {
            id: Order.id,
            status:"Cancelled"
          }

          const { getStoreSettings } = require('../graphql/queries');
          let stripeDisabled = false;
          try {
            const settingsRes = await API.graphql(graphqlOperation(getStoreSettings, { id: 'default' }));
            if (settingsRes.data.getStoreSettings) {
              stripeDisabled = settingsRes.data.getStoreSettings.stripeDisabled;
            }
          } catch (err) {}

          // Trigger refund and email
          const { clientSecret } = await API.post('comlambda', '/cancelcharge', {
            body: {
              charge: {
                amount: Order.price,
                privatekey: Order.paymentIntent,
                is_refund: 2,
                disableStripe: stripeDisabled,
                customerEmail: (user && user.attributes && user.attributes.email) || '',
                customerName: (user && user.attributes && user.attributes.name) || (user && user.attributes && user.attributes.email) || 'Customer',
                orderId: Order.id
              }
            }
          });

          const result = await API.graphql(graphqlOperation(updateOrder, { input }))
          console.log({ result })
          Notification({
            title: "success",
            message: "Order Canceled  Successfully !",
            type: "success"
          });

         setTimeout(() => window.location.reload(), 2000);

        } catch (err) {
          Message({
            type: 'info',
            message: 'Delete Profile cancelled',
          })
          console.error(`Failed to cancel Order with id: ${Order.id}`, err);

        }


      })
      .catch(() => {
        Message({
          type: 'info',
          message: 'operation aborted',
        })
      })
  }


  const handlePaymentOrder = (Order) => {
    MessageBox.confirm(
      'This will Process Payment  for your Order! Continue?',
      'Attention!',
      {
        confirmButtonText: 'Process Payment',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }
    )
      .then(async () => {
        try {

          console.log("my order ", Order);
          const input = {
            id: Order.id,
            status:"Ready for Pickup"
          }


          const { getStoreSettings } = require('../graphql/queries');
          let stripeDisabled = false;
          try {
            const settingsRes = await API.graphql(graphqlOperation(getStoreSettings, { id: 'default' }));
            if (settingsRes.data.getStoreSettings) {
              stripeDisabled = settingsRes.data.getStoreSettings.stripeDisabled;
            }
          } catch (err) {}

          const { clientSecret } = await API.post('comlambda', '/cancelcharge', {
            body: {
              charge: {
                amount: Order.price,
                privatekey: Order.paymentIntent,
                is_refund: 0,
                disableStripe: stripeDisabled
              }
            }    
          })
          const result = await API.graphql(graphqlOperation(updateOrder, { input }))
          console.log({ result })
        
          Notification({
            title: "success",
            message: "Payment Processed & Order Updated  Successfully !",
            type: "success"
          });
         
          setTimeout(() => window.location.reload(), 2000);

        } catch (err) {
          Message({
            type: 'info',
            message: 'Payment Process  cancelled',
          })
          console.error(`Failed to Payment Process Order with id: ${Order.id}`, err);

        }


      })
      .catch(() => {
        Message({
          type: 'info',
          message: 'operation aborted',
        })
      })
  }



  const handleStatusChange = (e, orderId) => {
    setstatus(e.target.value);
  }


  const handleOrderUp = (OrderId) => {
    MessageBox.confirm(
      'This will update your order status  ! Continue?',
      'Attention!',
      {
        confirmButtonText: 'Update',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }
    )
      .then(async () => {
        try {

          const input = {
            id: OrderId,
            status
          }

          const result = await API.graphql(graphqlOperation(updateOrder, { input }))
          console.log({ result })
          Notification({
            title: "success",
            message: "Order updated Successfully !",
            type: "success"
          });

          setTimeout(() => window.location.reload(), 2000);

        } catch (err) {
          console.error(`Failed to update Order with id: ${OrderId}`, err);

        }

      })
      .catch(() => {
        Message({
          type: 'info',
          message: 'Order Update  cancelled',
        })
      })
  }

  
    


                
  const orders = filteredOrders.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

  return (
    <>
      <OrderSearch
        filters={filters}
        onChange={handleFilters}
        total={allOrders.length}
        found={filteredOrders.length}
      />

      <NumberPager page={page} pageCount={pageCount} onPage={goToPage} disabled={isLoading} />

      {isLoading && <EmptyMsg>Loading orders…</EmptyMsg>}

      {orders.length === 0 && !isLoading && (
        <EmptyMsg>
          {hasActiveFilters(filters) ? 'No orders match your search.' : 'No orders yet.'}
        </EmptyMsg>
      )}

      {orders.map(order => (
        <OrderCardItem
          key={order.id}
          order={order}
          isAdmin={isAdmin}
          actionButtons={
            isAdmin ? (
              <>
                <Button
                  type="info"
                  icon="edit"
                  size="small"
                  onClick={() => handlePaymentOrder(order)}
                >
                  Ready for Delivery
                </Button>

                <Button
                  type="danger"
                  icon="edit"
                  size="small"
                  onClick={() => handleCancelOrder(order)}
                >
                  Cancel Order
                </Button>
              </>
            ) : null
          }
        />
      ))}

      {orders.length > 0 && (
        <NumberPager page={page} pageCount={pageCount} onPage={goToPage} disabled={isLoading} />
      )}
    </>
  )






}


export default CustomerOrder;
